import { render, staticRenderFns } from "./VehicleSelectionForm.vue?vue&type=template&id=8c1f2dde&scoped=true&"
import script from "./VehicleSelectionForm.vue?vue&type=script&lang=js&"
export * from "./VehicleSelectionForm.vue?vue&type=script&lang=js&"
import style0 from "./VehicleSelectionForm.vue?vue&type=style&index=0&id=8c1f2dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1f2dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})
